import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSlice as selectSlice$1 } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import { name } from "../../config/name.js";
import { selectors } from "../slice.js";
import { selectSlice } from "./selectSlice.js";
const selectFavoriteVehiclesParameters = createAppSelector(
  [
    selectSlice,
    selectSlice$1,
    (state) => selectors.selectIds(state[name]),
    (_, offset) => offset ?? 0
  ],
  (favoriteSlice, config, favoriteVehicleIds, offset) => {
    const { spaceId, envId } = config;
    return {
      spaceId,
      envId,
      filter: {
        q: [`id in ['${favoriteVehicleIds.join(`', '`)}']`]
      },
      options: {
        options: {
          ...favoriteSlice.options,
          offset
        }
      }
    };
  }
);
export {
  selectFavoriteVehiclesParameters
};
